import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=762577d7&scoped=true&"
import script from "./NotificationBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./NotificationBadge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&id=762577d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762577d7",
  null
  
)

export default component.exports